__turbopack_context__.v({
  "collapseWrapper": "MobileNav-module__-8gx6W__collapseWrapper",
  "open": "MobileNav-module__-8gx6W__open",
});
